import { ProductTechMapAdditionalStatusAdmin, ProductTechMapStatus } from '@/shared/state/api/swagger';

type TechCardStatuses = ProductTechMapStatus | ProductTechMapAdditionalStatusAdmin;

export const TECH_CARD_CLOSED_STATUSES: TechCardStatuses[] = ['canceled', 'released', 'completed'];
export const TECH_CARD_ISSUE_DETAILS_STATUSES: TechCardStatuses[] = ['accepted_at_sgd', 'partially_issued'];
export const TECH_CARD_IN_PROGRESS_STATUSES: TechCardStatuses = 'progress';
